<template>
  <div
    v-dompurify-html="translatedChange"
    class="sf-layer-border-bottom sf-pad-1"
    data-testid="audit-log-item__audited_change"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'LedgerAuditLogAttributeChange',
})

interface Props {
  change: {
    changes: string[]
    originalAttribute: string
    attribute: [field: number]
  }
}
const props = defineProps<Props>()

const translatedChange = computed(() => {
  const { changes, originalAttribute, attribute: field } = props.change
  const [from, to] = changes.map(
    (value) => value || window.I18n.t('common.empty')
  )

  if (originalAttribute && originalAttribute.endsWith('_id')) {
    return window.I18n.t('audit.changed_field_no_diff', { field })
  } else {
    return window.I18n.t('audit.changed_field_html', { field, from, to })
  }
})
</script>
